import { infoColor, primaryColor, successColor } from 'assets/jss/material-dashboard-pro-react';

const uploadedFileStyle = () => ({
	uploadSingleFile: {
		margin: '15px 0',
		minWidth: 250,
		display: 'flex',
		flexDirection: 'row',
	},
	checkIcon: {
		fontSize: '32px',
		color: successColor[0],
	},
	uploadProofSingleFileText: {
		width: '80%',
		paddingLeft: '5px',
		'& > p': {
			maxWidth: 175,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
	},
	iconsWrapper: {
		display: 'flex',
		marginLeft: 37,
		'& > div': {
			marginRight: 20,
			'&:last-of-type': {
				marginRight: 0,
			},
		},
	},
	icon: {
		fontSize: '32px',
		color: primaryColor[0],
		cursor: 'pointer',
		'&:hover svg': {
			color: `${infoColor[1]} !important`,
		},
	},
});

export default uploadedFileStyle;
